var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.251 16.276L15.188 3.251a3.75 3.75 0 00-6.377 0L.747 16.276A3.75 3.75 0 003.936 22h16.127a3.75 3.75 0 003.188-5.724zm-1.66 2.825a1.73 1.73 0 01-1.529.899H3.936a1.749 1.749 0 01-1.488-2.671l8.064-13.025a1.75 1.75 0 012.976 0l8.063 13.024a1.728 1.728 0 01.04 1.774z",
    fill: "#FA8C16"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12h-2.234l2.091-3.485-1.714-1.03-3 5A1 1 0 0010 14h2.234l-2.091 3.485 1.714 1.03 3-5A1 1 0 0014 12z",
    fill: "#FA8C16"
  })));
}

export default __webpack_public_path__ + "./fonts/warning.eff061ccaf93c3179b16bcc85c8e6333.svg";
export { SvgWarning as ReactComponent };